import { doc, increment, setDoc } from 'firebase/firestore';
import { db } from '../config/FirebaseConfig';

// Data de hoje no fuso de Brasília (AAAA-MM-DD), igual ao id usado em clarity_daily.
const todayId = () => new Date().toLocaleDateString('en-CA', { timeZone: 'America/Sao_Paulo' });

// Contador diário em site_events/{data} para os relatórios do /admin.
// Ex.: chat_open com chat_intent "contratar" soma em chat_open e chat_open__contratar.
function countEvent(event, params) {
  const counts = { [event]: increment(1) };
  if (params.chat_intent) counts[`${event}__${params.chat_intent}`] = increment(1);
  setDoc(doc(db, 'site_events', todayId()), { counts }, { merge: true }).catch((error) =>
    console.warn('[track] contador', error)
  );
}

// Envia o evento para o GTM (GA4), para o Microsoft Clarity e para o contador do /admin.
// Não mande dados pessoais (nome, telefone) nos parâmetros.
export function track(event, params = {}) {
  try {
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event, ...params });
    }
    if (typeof window.clarity === 'function') {
      window.clarity('event', event);
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) window.clarity('set', key, String(value));
      });
    }
    countEvent(event, params);
  } catch (error) {
    console.warn('[track]', error);
  }
}
